var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{staticClass:"width-full",attrs:{"options":_vm.provinceCityOptions,"props":_vm.elCascaderProps,"placeholder":"Por favor, elija"},on:{"change":_vm.handleChangeProvinceCity},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }